module.exports = __webpack_public_path__ + "static/media/discovery.b89a2f9f.svg";